import SwBannerCard from './sw-banner-card.vue';
export { SwBannerCard };
